const feedbackButtonStyles = {
    button: `fixed bottom-12 screen-498:bottom-8 left-8 z-[1000] cursor-pointer !bg-primaryButton !text-themeColor !border-primaryButton !py-2 !px-2 !screen-498:px-[40px] !screen-498:py-[12px] shadow-lg transition-all active:scale-95 flex items-center justify-center font-normal !text-[14px] sm:text-[16px] hover:!text-white`,
}

export { feedbackButtonStyles }
